import PropTypes from 'prop-types';
import Rodal from 'rodal';
import React, { useCallback, useEffect, useState } from 'react';
import JSZip from 'jszip';
import { Line } from 'rc-progress';

const BatchDownloadDocumentsModal = ({ visible, onClose, documents }) => {
  const [dowloadedFiles, setDowloadedFiles] = useState(0);
  const [zipBlob, setZipBlob] = useState();

  const downloadFiles = async () => {
    const zip = new JSZip();

    await Promise.all(documents.map(async (doc) => {
      try {
        const response = await fetch(doc.external_url);

        // FIXME: Adicionar fluxo de retry e feedback.
        if (!response.ok) {
          console.log(`Failed to fetch ${doc.external_url}`);

          return;
        }

        const blob = await response.blob();
        zip.file(doc.name, blob);

        setDowloadedFiles(prev => prev + 1)

      } catch (error) {
        console.error(`Error fetching ${doc.external_url}:`, error);
      }
    }))

    setZipBlob(await zip.generateAsync({ type: 'blob' }))
  }

  const downloadZip = useCallback(() => {
    const link = document.createElement('a');

    link.href = URL.createObjectURL(zipBlob);
    link.download = 'documentos.zip';
    link.click();
    onClose();

  }, [zipBlob])

  useEffect(() => {
    if (!documents.length || !visible) return

    setZipBlob(null);
    setDowloadedFiles(0);
    downloadFiles();
  }, [documents, visible])

  const progress = documents.length ? (100 * dowloadedFiles / documents.length) : 0;

  return (
    <Rodal
      visible={visible}
      onClose={onClose}
      closeOnEsc
      height={250}
      width={700}
    >
      <div className="d-flex flex-column h-100">
        <div className="modal-header">
          <div className="text-center">
            <h2>Download de documentos em lote</h2>
          </div>
        </div>
        <div className="modal-body">

          <span>Realizando download dos documentos do candidato: {progress || 0} %</span>
          <Line percent={progress} strokeWidth="1" strokeColor="#00ae97" />
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={onClose}
            className="btn-danger btn blue"
          >
            Cancelar
          </button>
          <button
            type="button"
            disabled={progress < 100}
            onClick={() => downloadZip()}
            className="btn-primary btn blue"
          >
            Salvar
          </button>
        </div>
      </div>
    </Rodal>
  )
}

BatchDownloadDocumentsModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  documents: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    external_url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }))
};

BatchDownloadDocumentsModal.defaultProps = {
  onClick: () => null,
};

export default BatchDownloadDocumentsModal;
